import { Fragment } from "react";
import { useSelector } from "react-redux";

export const IntroPage = props => {
    const { title, items, ...other } = props;

    const currentTheme = useSelector(state => state.currentTheme);
    const appearance = useSelector(state => state.appearance);

    return (
        <Fragment>
            <div className="intro-page-wrapper">
                {
                    title &&
                    <div className="title">{title}</div>
                }    
                <div className="intro-page">                              
                {
                    items.map((item, index) => 
                    {
                    return (
                        <div key={index} className="item">
                            <item.icon className="external-icon"  width={item.width} height={item.height} />
                            <div className="content">{item.content}</div>
                        </div>
                    )            
                    })
                }
                </div>
            </div>
            <style>
                {
                    `
                    .intro-page-wrapper
                    {
                        width: 100%;
                        height: 100%;
                        border: ${currentTheme.pageHelpBorder};
                        border-radius: ${currentTheme.pageBorderRadius};
                        background-color: ${currentTheme.pageIntroBg};    
                        display: flex;
                        flex-direction: column;
                        overflow-y: hidden;                        
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"}
                    }

                    .intro-page-wrapper .title
                    {
                        font-size: 17px;
                        font-weight: 700;
                        color: ${currentTheme.touchColor};
                        padding: 6px 16px 6px 16px;
                        font-style: italic;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                    }

                    .intro-page
                    {
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        width: 100%;
                        padding: 20px 16px;
                        flex: 1;
                        overflow-y: auto;
                    }                                                            
                    
                    .intro-page > .item
                    {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 25%;
                        padding: 22px 22px 42px 22px;
                        margin-top: 12px;
                    }

                    .intro-page .item .external-icon
                    {
                        margin-right: 16px;
                        color: ${currentTheme.touchColor};
                    }
                    
                    .intro-page .item .external-icon path
                    {
                        fill: ${currentTheme.touchColor};
                    }     
        
                    .intro-page .item .content
                    {
                        margin-top: 6px;
                    }
                    `
                }
            </style>
        </Fragment>
    );
};